import React from 'react'
import { Icon, Upload, Modal } from 'antd'
import Cropper from 'react-cropper'
import 'cropperjs/dist/cropper.css'
import './index.less'

const uploadButton = (
  <div>
    <Icon type='plus' />
    <div className='ant-upload-text'>Загрузить</div>
  </div>
)

export default class FileUpload extends React.Component {
  constructor(props) {
    super(props)
    // console.log(props)

    this.state = {
      fileList: [],
      base64: `data:image/jpeg;base64, ${props.value.replace(/ /g, '+')}`,
      visibleModal: false,
      cropImage: `data:image/jpeg;base64, ${props.value.replace(/ /g, '+')}`,
    }

    this.cropperRef = React.createRef()

    this.handleChange = this.handleChange.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.cropImg = this.cropImg.bind(this)
    this.setPicture = this.setPicture.bind(this)
  }

  handleChange(e) {
    if (e.file.originFileObj) {
      new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(e.file.originFileObj)
        reader.onload = () => {
          this.setState({ visibleModal: true })
          this.setState({ base64: reader.result })
          let encoded = reader.result.replace(/^data:(.*;base64,)?/, '')
          if (encoded.length % 4 > 0) {
            encoded += '='.repeat(4 - (encoded.length % 4))
          }
          resolve(encoded)
          return encoded
        }
        reader.onerror = error => reject(error)
      })
    }
  }

  hideModal() {
    this.setState({ visibleModal: false })
  }

  cropImg() {
    this.setState({ cropImage: this.cropperRef.current.cropper.getCroppedCanvas().toDataURL('image/jpeg') })
  }

  setPicture() {
    this.setState({ base64: this.state.cropImage })
    this.props.onChange(this.state.base64.replace(/^data:(.*;base64,)?/, ''))
    this.setState({ visibleModal: false })
  }

  render() {
    const fileList = this.state.fileList
    const base64 = this.state.base64
    const visible = this.state.visibleModal

    return (
      <div>
        <Upload
          // accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          action='https://cabinet.maxbonus.ru/cloud/service_admin.php'
          onChange={this.handleChange}
          onRemove={this.removeFile}
          fileList={fileList}
          listType='picture-card'
        >
          {base64 ? (
            <img className='picture' alt='picture' src={base64} />
            ) : (
              uploadButton
            )}
        </Upload>
        <Modal
          title='Выбор фрагмента'
          viewMode={3}
          visible={visible}
          okText='Применить'
          onOk={this.setPicture}
          cancelText='Отменить'
          onCancel={this.hideModal}
        >
          <Cropper
            ref={this.cropperRef}
            src={base64}
            // scaleX={0.2}
            style={{ height: 400, width: '100%' }}
            aspectRatio={1}
            initialAspectRatio={2}
            guides={false}
            crop={this.cropImg}
          />
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/containers/ActionForm/UploadPicture.jsx